import React from 'react';
import PropTypes from 'prop-types';
import VerticalTab from '../VerticalTab';
import { PurpleGuideWrapper, PurpleGuideTab } from './styles';

const PurpleGuide = ({ id, userId, defaultOpen = false, forceOpen = false, texts, context = {} }) => {
  const localStorageKey = `purpleGuide_${id}_${userId}`;
  const purpleGuideTexts = i18n.locales[i18n.getLocale()]['purpleGuideTexts'] || {};
  const defaultTexts = {
    tabheader: i18n.__('guide_tabheader'),
    header: '',
    subheader: i18n.__('guide_subheader'),
    footer: i18n.__('guide_footer'),
    items: [],
  };
  const guideTexts = { ...defaultTexts, ...purpleGuideTexts[id], ...texts };

  const disabledByUser = document.querySelector('body').getAttribute('data-user-disable-purple-guide') === 'true';

  return (
    <VerticalTab
      id={`purpleGuide_${id}`}
      order={0}
      texts={guideTexts}
      defaultOpen={defaultOpen}
      forceOpen={forceOpen}
      TabComponent={PurpleGuideTab}
      WrapperComponent={PurpleGuideWrapper}
      openClassName="guide-open"
      context={context}
      disabledByUser={disabledByUser}
      localStorageKey={localStorageKey}
    />
  );
};

PurpleGuide.propTypes = {
  id: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  defaultOpen: PropTypes.bool,
  forceOpen: PropTypes.bool,
  texts: PropTypes.shape(),
  context: PropTypes.shape(),
};

export default PurpleGuide;
